/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"
import { useId } from "react"

interface TextFilterProps {
    value: string
    onChange: (text: string) => void
    placeholder?: string
    label?: string
    className?: string
}

export function TextFilter({
    value,
    onChange,
    placeholder = "Search...",
    label,
    className = ""
}: TextFilterProps): JSX.Element {
    const id = useId()
    const inputElement = (
        <input
            id={id}
            type="text"
            className="form-control"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
        />
    )

    // Floating label
    if (label) {
        return (
            <div className={`form-floating ${className}`}>
                {inputElement}
                <label htmlFor={id}>{label}</label>
            </div>
        )
    }

    // No label → normal layout
    return <div className={className}>{inputElement}</div>
}
